import http from "./http";

export default {
    addOrEditEqu(params){
        return http.post("common-user/device/repo/saveDeviceParent", params);
    },

    mainEquList(params){
        return http.get("common-user/device/repo/queryDeviceParent",{ params });
    },

    delMainEqu(params){
        return http.post("common-user/device/repo/deleteDeviceParent", params);
    },

    getMainDetail(params){
        return http.get("common-user/device/repo/queryDeviceChildByParentId",{ params });
    },

    delChildEqu(params){
        return http.post("common-user/device/repo/deleteDeviceChild",params);
    },

    addOneChild(params){
        return http.post("common-user/device/repo/saveDeviceChild",params);
    },

    getChildEquList(params){
        return http.get("common-user/device/repo/queryDeviceChild" ,{ params })
    },

    addCheckChildEqu(params){
        return http.post("common-user/device/repo/setDeviceParentAndChild",params);
    },

    beginPairEqu(params){
        return http.post("common-user/device/repo/setAssociated",params);
    },

    endPairEqu(params){
        return http.post("common-user/device/repo/stopAssociated",params);
    },

}
